import { render, staticRenderFns } from "./tree-org.vue?vue&type=template&id=545651e2&scoped=true&"
import script from "./tree-org.vue?vue&type=script&lang=js&"
export * from "./tree-org.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545651e2",
  null
  
)

export default component.exports